import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleZoneRemoval(
  state: State,
  zone: Boundaries["removeZone"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    zones: req.zones.filter(({ uuid }) => uuid !== zone.uuid),
  }));
}

export { handleZoneRemoval };
